import React, { memo } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { validators } from "investira.sdk";
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "investira.react.components";

/**
 * Renderiza o componente IndicadorSelect.
 *
 * @param {Object} props - Propriedades do componente.
 * @param {string} props.label - Propriedade `label` do componente.
 * @param {string} props.defaultValue - Propriedade `defaultValue` do componente.
 * @param {Function} props.onChange - Propriedade `onChange` do componente.
 *
 * @description
 * Este componente realiza as seguintes operacoes:
 * 1. Recebe as propriedades necessarias para compor a interface
 * 2. Organiza os estados e callbacks usados durante a renderizacao
 * 3. Renderiza a experiencia visual do organismo
 *
 * @returns {JSX.Element|null} Elemento renderizado pelo componente.
 */

const IndicadorSelect = memo((props) => {
  const indicadores = useSelector((state) => state.indicadores.data);

  const handleChange = (event) => {
    props.onChange && props.onChange(event);
  };

  if (validators.isEmpty(props.tipoId)) {
    console.error("tipoId não informado");

    return;
  }

  return (
    <FormControl fullWidth>
      <InputLabel shrink={true} id="moeda-select-label">
        {props.label}
      </InputLabel>
      <Select
        labelId="moeda-select-label"
        id="moeda-select"
        defaultValue={props.defaultValue}
        value={props.value}
        label={props.label}
        name={props.name}
        onChange={handleChange}
        disabled={props.disabled}
      >
        {!validators.isEmpty(indicadores) &&
          indicadores[props.tipoId].map((xItem) => {
            return (
              <MenuItem key={xItem.indicador_id} value={xItem.indicador_id}>
                {`${xItem.indicador_seuid} - ${xItem.indicador}`}
              </MenuItem>
            );
          })}
      </Select>
    </FormControl>
  );
});

IndicadorSelect.propTypes = {
  label: PropTypes.string,
  defaultValue: PropTypes.string,
  onChange: PropTypes.func,
  tipoId: PropTypes.oneOf(["M", "C", "I", "J"]),
};

IndicadorSelect.defaultProps = {};

IndicadorSelect.displayName = "IndicadorSelect";

export default IndicadorSelect;
